import React, { useState, useCallback, useEffect } from 'react';
import { PageHeaderSection } from '../../components/common/PageHeadSection';
import { useTranslation } from 'react-i18next';
import { HotelSelect } from '../../components/common/HotelSelect';
import { useQuery } from 'react-query';
import { mdlParameterListRequest } from '../../models/service-models/parameter/ParameterListRequest';
import { Skeleton } from 'antd';
import { mdlParameter } from '../../models/domain/Parameter';
import _ from 'lodash';
import AgencyList from '../../components/agencies/AgencyList';
import { AgencyService } from '../../services/AgencyService';
import { toast } from 'react-toastify';
import { ObjectHelper } from '../../utils/ObjectHelper';

const Agencies = () => {
    const { t } = useTranslation();
    const [selectedHotel, setSelectedHotel] = useState<string>();
    const [request, setRequest] = useState<mdlParameterListRequest>({ pageNumber: 1, pageSize: 10 });
    const [search, setSearch] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false); // Loading state

    const handleHotelSelect = useCallback((hotelId: string) => {
        setSelectedHotel(hotelId);
        setRequest({ pageNumber: 1, pageSize: 10 });
        setSearch("");
        setLoading(true);
    }, []);

    const {
        data,
        isLoading,
        refetch
    } = useQuery(
        ["getAgencies", selectedHotel, search],
        () => selectedHotel
            ? AgencyService.List({ ...request, hotelId: selectedHotel, name: search })
            : null,
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedHotel,
        }
    );

    useEffect(() => {
        if (!isLoading) {
            setLoading(false);
            if (data && data.header.success === false) {
                toast.error(ObjectHelper.getErrorMessage(data.header.messages))
            }
        }
    }, [data, isLoading, t]);

    return (
        <>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection pageTitle={t("agencies.title")} />
                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-12">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                <HotelSelect onChange={handleHotelSelect} />
                                                {loading ? (
                                                    <Skeleton active />
                                                ) : (
                                                    <AgencyList
                                                        agencies={data?.body}
                                                        hotelId={selectedHotel}
                                                        refreshList={(search: string) => setSearch(search)}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Agencies;
